import { render, staticRenderFns } from "./sendStoreOrderCart.vue?vue&type=template&id=28742f62&scoped=true"
import script from "./sendStoreOrderCart.vue?vue&type=script&lang=js"
export * from "./sendStoreOrderCart.vue?vue&type=script&lang=js"
import style0 from "./sendStoreOrderCart.vue?vue&type=style&index=0&id=28742f62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28742f62",
  null
  
)

export default component.exports